module.exports = __webpack_public_path__ + "img/expenses.c6931d48.svg";